import React, { useState, useEffect } from 'react'
import { numberParseChina, repairFormatNum, momentFormat } from "@/utils/utils";
import { useChargebackModel } from '../chargebackModel';
import { chargebackService } from "../chargebackService"
import { IMaterialDetailList, IItemDetailList, IChargebackDetail } from '../chargebackType';
import { ScaniaPrint, IPrintClumns } from "@/components/ScaniaPrint"
import useGlobalModel from '@/model/globalModel';
export const ScaniaPrints = () => {
    const { scaniaPrint: { visible, type }, selectedRow, setScaniaPrint } = useChargebackModel()
    const { shopAndOrg: { shopCode } } = useGlobalModel()
    const onClose = () => {
        setScaniaPrint({ visible: false, type: 1 })
    }
    const [formVal, setFormVal] = useState<IChargebackDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const { CustomerData, shopAndOrg: { shopName, shopId } } = useGlobalModel()
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await chargebackService.one(selectedRow.returnCode as string);
        let { itemDetails, materialDetails, receivableTotalAmount, enterTime, deliveryTime, workingHoursAmount, materialScienceAmount, ...from } = retData
        receivableTotalAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : repairFormatNum(receivableTotalAmount)
        workingHoursAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : workingHoursAmount
        materialScienceAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : materialScienceAmount

        const newItemDetails = itemDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        const newMaterialDetails = materialDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IMaterialDetailList[] ?? []);
            setItemList(newItemDetails as IItemDetailList[] ?? []);
            setFormVal({
                ...from,
                receivableTotalAmount,
                materialScienceAmount,
                workingHoursAmount,
                receivableTotalAmountCN: numberParseChina(receivableTotalAmount),
                enterTime: momentFormat(enterTime),
                deliveryTime: momentFormat(deliveryTime)

            })

        }
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
            // render:(text:any)=>formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 :text
        },
        type === 1 ? {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        } : {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => 0
        },
        type === 1 ? {
            title: '折扣',
            dataIndex: 'discountRate',
            // render: (text: any) => text + "%"
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? "100%" : text + "%"
        } : {
            title: '折扣',
            dataIndex: 'discountRate',
            render: (text: any) => 0
        },
        type === 1 ? {
            title: '工时费',
            dataIndex: 'receivableAmount',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        } : {
            title: '工时费',
            dataIndex: 'receivableAmount',
            render: (text: any) => 0
        },
        {
            title: '备注',
            dataIndex: 'note',
            colSpan: 2
        },
    ]
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '材料编号',
            dataIndex: 'materialCode',
        },
        {
            title: '材料名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
            // render:(t:any)=> formVal.serviceNatureCode + t
            // render:(text:any)=>formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 :text
        },
        type === 1 ? {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        } : {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => 0
        },
        type === 1 ? {
            title: '折扣',
            dataIndex: 'discountRate',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? "100%" : text + "%"
        } : {
            title: '折扣',
            dataIndex: 'discountRate',
            render: (text: any) => 0
        },
        type === 1 ? {
            title: '金额',
            dataIndex: 'receivableAmount',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        } : {
            title: '金额',
            dataIndex: 'receivableAmount',
            render: (text: any) => 0
        },
        shopCode === "SHOP-M-00000017" || shopCode === "SHOP-M-00000018" ? {
            title: '货位',
            dataIndex: 'shelfCode',
        } :
            {
                title: '备注',
                dataIndex: 'note',
            },
    ]
    // let IHeader = [
    //     {
    //         fieldLabel: "工号：",
    //         fieldValue: formVal.returnCode
    //     }, {
    //         fieldLabel: "支付方式：",
    //         fieldValue: formVal.paymentMethodName
    //     }, {
    //         fieldLabel: "打印日期：",
    //         fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
    //     },
    // ]
    return <ScaniaPrint
        title={`${shopName}`}
        visible={visible}
        onClose={onClose}
        columns={columns as IPrintClumns[]}
        itemClumns={itemClumns as IPrintClumns[]}
        itemDataSource={itemList}
        dataSource={maintenanceList.filter(item => item.num !== 0)}
        formVal={formVal}
        shopCode={shopCode}
        type={type}

    />
}
